import { QueryClient } from "@tanstack/react-query";

import { logOnDev } from "@/services/axios/interceptors/response";

import { PusherUpdateEventData } from "../../types";
import { baseOrganisationChannelUpdateFn } from "./base-organisation-channel-update-fn";

export const organisationChannelUpdateFn = (
  queryClient: QueryClient,
  data: PusherUpdateEventData
) => {
  logOnDev("[‼️][UPDATE EVENT]", data);

  baseOrganisationChannelUpdateFn(queryClient, data);
};
